export default async function GetRoleMaster(clientId) {
    let url = window.UserService + `/api/RoleMaster/GetRoleNamebyClientId?clientId=${clientId}`
    let response = {}

    let head = {
        "Content-Type": "application/json",
        'accept': '*/*'
    }
    response = await fetch(url, {
        method: "GET",
        headers: head,
        // body: JSON.stringify(senddata)
    }).then(res => res.json()).then(response)
    return response;
}